import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../../common/global-constants';
import { customfunctions, DataParam } from '../../../common/customfunctions';
import { ApiMethod } from '../../../apimethods/api-method';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import * as Highcharts from 'highcharts';

declare var $;

@Component({
  selector: 'app-emp-graph',
  templateUrl: './emp-graph.component.html',
  styleUrls: ['./emp-graph.component.css']
})
/** emp-graph component*/
export class EmpGraphComponent {

  /** emp-graph ctor */
  constructor() {

  }
  ngAfterViewChecked(): void {
    $('#divempgraph .highcharts-legend-item').hide();
  }

  PoorRange = ''; ModerateRange = ''; GoodRange = ''; ExcellentRange = '';
  highchartsColEmpGraph: typeof Highcharts = Highcharts; chartOptionsColEmpGraph;
  LoadColChartData(categoryList, chartSeriesList, graphHeading, thresholdRangeData) {

    let self = this;

    var _rangeList = thresholdRangeData.filter(a => a.Type == graphHeading);

    let dataSeries: any = [];
    let _poorRange = 50;
    let _moderateRange1 = 50; let _moderateRange2 = 79;
    let _goodRange1 = 80; let _goodRange2 = 94;
    let _excellentRange = 94;

    if (_rangeList.length > 0) {

      if (_rangeList[0].PoorRange != null) {
        _poorRange = parseInt(_rangeList[0].PoorRange);
        $('#sp' + graphHeading + 'Poor,#spPoor').html('<' + _rangeList[0].PoorRange + '%');
      }

      if (_rangeList[0].ModerateRange != null) {
        let _split = _rangeList[0].ModerateRange.split('-');
        if (_split.length === 2) {
          _moderateRange1 = parseInt(_split[0]);
          _moderateRange2 = parseInt(_split[1]);
          $('#sp' + graphHeading + 'Moderate,#spModerate').html('' + _split[0] + '-' + _split[1] + '%');
        } else {
          console.error('Invalid ModerateRange format:', _rangeList[0].ModerateRange);
        }
      }

      if (_rangeList[0].GoodRange != null) {
        let _split = _rangeList[0].GoodRange.split('-');
        if (_split.length === 2) {
          _goodRange1 = parseInt(_split[0]);
          _goodRange2 = parseInt(_split[1]);
          $('#sp' + graphHeading + 'Good,#spGood').html('' + _split[0] + '-' + _split[1] + '%');
        } else {
          console.error('Invalid GoodRange format:', _rangeList[0].GoodRange);
        }
      }
      if (_rangeList[0].ExcellentRange != null) {
        _excellentRange = parseInt(_rangeList[0].ExcellentRange);
        $('#sp' + graphHeading + 'Excellent,#spExcellent').html('≥' + _rangeList[0].ExcellentRange + '%');
      }

      if (_rangeList[0].RoleId == 0) {
        $('#divMainThreshold').show();
        $('.div' + graphHeading + 'RangePanel').hide();
      }
      else {
        $('#divMainThreshold').hide();
        $('.div' + graphHeading + 'RangePanel').show();
      }
    }
    else {
      $('.div' + graphHeading + 'RangePanel').hide();
    }


    $.each(chartSeriesList, function (e, val) {

      let _color = 'blue';
      if (val.y <= _poorRange) {
        _color = '#DC143C';
      }
      else if (val.y >= _moderateRange1 && val.y < _moderateRange2) {
        _color = '#FF8800';
      }
      else if (val.y >= _goodRange1 && val.y < _goodRange2) {
        _color = '#5fd05f';
      }
      else if (val.y >= _excellentRange) {
        _color = '#2E8B57';
      }
      dataSeries.push({
        name: val.name, y: val.y, color: _color, showInLegend: false
      });
    });

    //Column Chart
    this.highchartsColEmpGraph = Highcharts;
    this.chartOptionsColEmpGraph = {
      chart: {
        type: 'column',
        style: {
          fontFamily: 'Poppins, Arial, sans-serif',
        },
        legend: {
          enabled: false // Hide the legend
        }
      },
      title: {
        text: graphHeading,
      },
      xAxis: {
        categories: categoryList,
        type: 'category',
      },
      yAxis: {
        title: {
          text: 'Values',
        }
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
          },
          //point: {
          //  events: {
          //    click: function () {
          //      self.LoadDateWiseData(this.category, graphHeading, thresholdRangeData);
          //    }
          //  }
          //}
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      series: [{
        name: graphHeading,
        data: dataSeries
      }]
    };
  }

  showChartTransModal: boolean;
  HideChartTransData() {
    $('#myModalChartTrans').hide();
  }
  LoadDateWiseData(dataValue, dataType, thresholdRangeData) {
    $('#divChartTransTitle').html(`${dataValue} - ${dataType}`);
    $('#myModalChartTrans').show();
  }

  highchartsColEmpGraphTrans: typeof Highcharts = Highcharts; chartOptionsColEmpGraphTrans;
}
